module.exports = __webpack_public_path__ + "media/react/assets/notFound-e9b87e2bd0ee0348bcdd835c3ad6a076.svg";